

const AuthReducer = (state,action) => {
    switch ((action.type)) {
        case "LOGIN_START":
            return{
                user:null,
                isFetching:true,
                error:false
            }
            
        case "LOGIN_SUCCESS":
            localStorage.setItem("UD",JSON.stringify(action.payload));
            var x = JSON.parse(localStorage.getItem("UD"))
            console.log(x)
            return{
                user:x,
                isFetching:false,
                error:false
            }
            
        case "LOGIN_FAILURE":
            return{
                user:null,
                isFetching:false,
                error:true
            }
        case "FOLLOW":
            return{
                ...state,
                user:{
                    ...state.user,
                    followings:[...state.user.followings,action.payload]
                }
            }
        case "UNFOLLOW":
            return{
                ...state,
                user:{
                    ...state.user,
                    followings:state.user.followings.filter(following => following !== action.payload )
                }
            }
            
    
        default:
            return state
            
    }
}

export default AuthReducer;